// extracted by css-extract-rspack-plugin
var _1 = "form-oO9Wpb";
var _2 = "versions-select-uQB_Iu";
var _3 = "versions-select-uQB_Iu";
export { _1 as "form", _2 as "versions-select", _3 as "versionsSelect" }
